import React from 'react';
import { unescapeQuotesInObject } from '~h/text';
import { 
  getCityNameByKLDARwithDadata 
} from '~h/cityCodes';

import messages from '~h/messages';

export const mapCompanyToRawData = company => {
  return {
    COMPANY_NAME: company.companyName ?? '',
    COMPANY_ID: company.id ?? '',
    INN: company.inn ?? '',
    KPP: company.kpp ?? '',
    CITY: company.city ?? '',
    CITY_CODE: company.cityCode ?? '',
    BANK_ACCOUNT: company.paymentAccount ?? '',
    CORR_ACCOUNT: company.paymentCorAccount ?? '',
    BIK: company.bankBik ?? '',
    BANK: company.bankName ?? '',
    LEGAL_ADDRESS: company.address ?? '',
    LOCATION_ADDRESS: company.factAddress ?? '',
  };
};

export const unescapeCompanies = array => {
  return array?.map(item => unescapeQuotesInObject(item)) || array;
};

export const getCompanyData = async userCompany => {
  const city = await getCityNameByKLDARwithDadata(userCompany.CITY_CODE);
  return { ...userCompany, CITY: city };
};

export const formMessages = {
  signerForm: 'Форма подписанта',
  studentsForm: 'Форма студента',
  companyForm: 'Форма компании',
};

export const getFormErrorElement = (formError) => {
  return (
    <React.Fragment>
      { messages.formError }:&nbsp;
      { formError.map((error, index) => <span className="form-message__highlight">{ index ?  `, ${error}` : error }</span>)}
    </React.Fragment>
  );
};